import { GET } from '../request'

export const getCentros = () => GET('/api/core/datos/centro/list/details')
